import MuiDialogActions from "@mui/material/DialogActions";
import React from "react";
export interface DialogActionsProps {
    className?: string;
    children: React.ReactNode;
}
export function DialogActions({ className, children }: DialogActionsProps) {
    return <MuiDialogActions className={className}>{children}</MuiDialogActions>;
}
